export default __webpack_public_path__ + "src/images/packages/zannier-hotels-sonop/0f606126374caa32f69e38fd2f7cc84b-5.jpg";